function stripTrailingSlash(pathname) {
    if (pathname.length > 0 && pathname.endsWith('/')) {
        return pathname.slice(0, -1);
    }

    return pathname;
}

function formatPrefix(locale, country) {
    const safeCountry = country ? country.toUpperCase() : null;

    if (!locale) {
        return null;
    }

    return safeCountry ? `/${locale}-${safeCountry}` : `/${locale}`;
}

function escapeForRegExp(value) {
    return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function stripCurrentPrefix(pathname, currentLocale, currentCountry) {
    if (!currentLocale) {
        return pathname;
    }

    const safeLocale = escapeForRegExp(currentLocale);
    const safeCountry = currentCountry ? escapeForRegExp(currentCountry) : null;

    const candidates = safeCountry
        ? [`/${safeLocale}-${safeCountry}`, `/${safeLocale}`]
        : [`/${safeLocale}`];

    const stripped = candidates
        .map(prefix => pathname.replace(new RegExp(`^${prefix}(?=/|$)`, 'i'), ''))
        .find(result => result !== pathname);

    return stripped !== undefined ? stripped : pathname;
}

function buildLocaleChangeUrl({
    locale,
    country = null,
    currentLocale = null,
    currentCountry = null,
    location = window.location,
} = {}) {
    const newPrefix = formatPrefix(locale, country);

    if (!newPrefix) {
        return `${location.pathname || '/'}${location.search || ''}${location.hash || ''}`;
    }

    const pathname = location.pathname || '/';
    const stripped = stripCurrentPrefix(pathname, currentLocale, currentCountry);
    const pathWithoutTrailingSlash = stripTrailingSlash(stripped);
    const newPath = pathWithoutTrailingSlash.length > 0
        ? `${newPrefix}${pathWithoutTrailingSlash}`
        : newPrefix;

    return `${newPath}${location.search || ''}${location.hash || ''}`;
}

export default buildLocaleChangeUrl;
